import React, { useEffect, useState } from 'react';
import api from '../api';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Tooltip, Button } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWorkOutlined';
import ApartmentIcon from '@mui/icons-material/ApartmentOutlined';
import ClearIcon from '@mui/icons-material/Clear';

const PropertyUnitSelector = ({ onSelect }) => {
  const [properties, setProperties] = useState([]);
  const [units, setUnits] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState('');
  const [selectedUnit, setSelectedUnit] = useState('');

  useEffect(() => {
    api.get('/api/properties')
      .then(res => setProperties(res.data))
      .catch(err => console.error('Failed to load properties:', err));
  }, []);

  useEffect(() => {
    if (selectedProperty) {
      // Find the selected property and get its units
      const property = properties.find(p => p.id === selectedProperty);
      if (property && property.units) {
        setUnits(property.units);
      } else {
        setUnits([]);
      }
    } else {
      setUnits([]);
    }
  }, [selectedProperty, properties]);

  useEffect(() => {
    if (selectedProperty && selectedUnit) {
      onSelect(selectedProperty, selectedUnit);
    } else {
      // Notify parent that filter is cleared
      onSelect('', '');
    }
  }, [selectedProperty, selectedUnit, onSelect]);

  const handleClearFilter = () => {
    setSelectedProperty('');
    setSelectedUnit('');
    setUnits([]);
  };

  return (
    <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <Tooltip title="Select a property to manage">
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="property-label">
            <HomeWorkIcon sx={{ mr: 1, verticalAlign: 'middle' }} /> Property
          </InputLabel>
          <Select
            labelId="property-label"
            value={selectedProperty}
            label={<><HomeWorkIcon sx={{ mr: 1, verticalAlign: 'middle' }} /> Property</>}
            onChange={e => setSelectedProperty(e.target.value)}
          >
            <MenuItem value="">-- Choose --</MenuItem>
            {properties.map(p => (
              <MenuItem key={p.id} value={p.id}>{p.name || p.id}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>
      <Tooltip title={selectedProperty ? "Select a unit in the chosen property" : "Select a property first"}>
        <FormControl sx={{ minWidth: 200 }} disabled={!selectedProperty}>
          <InputLabel id="unit-label">
            <ApartmentIcon sx={{ mr: 1, verticalAlign: 'middle' }} /> Unit
          </InputLabel>
          <Select
            labelId="unit-label"
            value={selectedUnit}
            label={<><ApartmentIcon sx={{ mr: 1, verticalAlign: 'middle' }} /> Unit</>}
            onChange={e => setSelectedUnit(e.target.value)}
          >
            <MenuItem value="">-- Choose --</MenuItem>
            {units.map(u => (
              <MenuItem key={u.id} value={u.id}>{u.name || u.id}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Tooltip>
      {(selectedProperty || selectedUnit) && (
        <Tooltip title="Clear filter and view all messages">
          <Button
            variant="outlined"
            size="medium"
            startIcon={<ClearIcon />}
            onClick={handleClearFilter}
          >
            Clear Filter
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};

export default PropertyUnitSelector;
